module.exports = __webpack_public_path__ + "img/5.052fcbf2.png";